export default __webpack_public_path__ + "media/images/lp/logo-082ea4526ff585b9b31f6431eb1452e6.png";